import { memo, useCallback, useContext } from "react";
import { useModals } from "@mantine/modals";
import ActionCard from "src/components/ActionCard";
import ProductDetail from "../ProductDetail";
import { ProductContext } from "src/api/context/ProductContext";

type IProductList = {
  isAllowWrite: boolean;
};

function ProductList({ isAllowWrite }: IProductList) {
  const { groupId, products, variantMetrics, productGroupData } =
    useContext(ProductContext);
  const modals = useModals();

  const handleModal = useCallback(
    (product = null) => {
      groupId &&
        modals.openModal({
          closeOnClickOutside: false,
          title: `${product ? "Update" : "Create"} Product`,
          children: (
            <ProductDetail
              formData={product}
              isModal={true}
              groupId={groupId}
              variantMetrics={variantMetrics}
              revenueCategoryId={productGroupData?.revenueCategory?.id}
              locationId={productGroupData?.location.id}
              isAllowWrite={isAllowWrite}
            />
          ),
        });
    },
    [groupId, variantMetrics, isAllowWrite]
  );

  return (
    <ActionCard
      title={"Products"}
      mb={"sm"}
      handleModal={isAllowWrite ? () => handleModal() : undefined}
      size="md"
      sx={{ height: "100%", minHeight: "40vh" }}
    >
      {products?.map((e) => (
        <ProductDetail
          key={e.id}
          formData={e}
          variantMetrics={variantMetrics}
          handleModal={handleModal}
          groupId={groupId}
          revenueCategoryId={productGroupData?.revenueCategory?.id}
          locationId={productGroupData?.location.id}
          isAllowWrite={isAllowWrite}
        />
      ))}
    </ActionCard>
  );
}

export default memo(ProductList);
